<template >
  <div
    class="CustomizePreference"
    v-if="show"
    :class="{ loading: loading > 0 }"
  >
    <div class="subtitle" v-if="userRooms.length > 1">
      {{ tran("ROOM_INDEX", { room: run("get", "currentUserRoomIndex") + 1 }) }}
    </div>
    <h2 class="title">{{ tran("CUSTOMIZE_PREFERENCE_TITLE") }}</h2>
    <div class="preference-items" v-if="items">
      <div
        class="preference-item item"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="wrapper">
          <h4 class="title" v-html="item.title"></h4>
          <div class="box">
            <div class="image">
              <img v-if="item.image" :src="item.image" />
            </div>
            <div class="desc">
              <div class="description" v-html="item.description"></div>
              <div class="read-more" v-if="item.detail">
                <a
                  class="pointer"
                  v-html="item.read_more ? item.read_more : tran('LEARN_MORE')"
                  @click.prevent="showDetail(item)"
                ></a>
              </div>
              <div class="options">
                <div
                  id="preference-click"
                  class="option pointer"
                  v-for="(option, index) in item.options"
                  :key="index"
                  @click.prevent="select(item, option)"
                  :disabled="
                    option.status != undefined && option.status != 1 ? '' : null
                  "
                  :class="{
                    selected:
                      run(
                        'get',
                        'rooms.' +
                          this.currentUserRoomIndex +
                          '.preference.' +
                          item.name
                      ) == option.value,
                  }"
                >
                  <span class="title" v-html="option.title"></span>
                  <span class="subtitle" v-html="option.subtitle"></span>
                </div>
              </div>

              <div
                class="maybe-later form-check"
                v-if="item.maybeLater != false"
              >
                <label class="form-check-label pointer">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :checked="
                      run(
                        'get',
                        'rooms.' +
                          this.currentUserRoomIndex +
                          '.preference.' +
                          item.name
                      ) == 'maybe'
                    "
                    @change="(e) => selectMaybe(e, item)"
                    value=""
                  />{{ tran("MAYBE_LATER") }}
                </label>
              </div>
              <div
                v-if="errors[index]"
                class="error"
                v-html="errors[index]"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="promotion-code toggle-slide"
      v-if="nextRoomIndex == -1"
      :class="{ active: showPromotion }"
    >
      <h4
        v-html="tran('PROMOTION_CODE_TITLE')"
        @click="showPromotion = !showPromotion"
      ></h4>

      <div>
        <div>
          <label v-html="tran('PROMOTION_CODE')"></label>
          <input
            v-model="promotionCode"
            type="text"
            :readonly="run('get', 'promotionCode', '') ? '' : null"
          />
          <button
            id="remove-promotion-btn"
            class="btn btn-danger"
            v-if="run('get', 'promotionCode', '')"
            @click.prevent="removePromotion"
            type="button"
          >
            {{ tran("REMOVE") }}
          </button>
          <button
            id="add-promotion-btn"
            class="btn btn-success"
            v-else
            @click.prevent="updatePromotion"
            type="button"
          >
            {{ tran("USE") }}
          </button>
        </div>
      </div>
    </div>
    <div class="buttons" v-if="nextRoomIndex > -1">
      <button
        id="next-room-preference-btn"
        type="button"
        class="btn btn-success"
        @click.prevent="run('next')"
      >
        {{ tran("CONTINUE_NEXT_ROOM") }}
      </button>
    </div>
    <div v-else class="buttons">
      <button
        id="next-step-review-pay-btn"
        type="button"
        class="btn btn-success"
        @click.prevent="run('next')"
      >
        {{ tran("REVIEW_PAY") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomizePreference",
  components: {},
  props: {
    run: Function,
  },
  data: function () {
    return {
      loading: 0,
      items: false,
      promotionCode: "",
      promotionName: "",
      errors: {},
      reload: false,
      showPromotion: false,
      enableShowPromotionPopup: true,
    };
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "customize_trip");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
    this.promotionCode = this.run("get", "promotionCode", "");
    this.showPromotion = this.promotionCode && this.promotionCode != "";
  },
  watch: {
    show(n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
    currentUserRoomIndex() {
      if (this.reload && this.show) {
        this.fetch();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    currentUserRoomIndex() {
      return this.run("get", "currentUserRoomIndex");
    },
    userRooms() {
      return this.run("get", "rooms");
    },

    nextRoomIndex() {
      let nextRoomIndex = this.userRooms.length;
      for (const roomIndex in this.userRooms) {
        const room = this.userRooms[roomIndex];
        if (
          !room.userChooseRoom ||
          !room.roomNumber ||
          !room.category ||
          !room.categoryType
        ) {
          nextRoomIndex = roomIndex;
        }
      }
      if (this.currentUserRoomIndex > nextRoomIndex) {
        return nextRoomIndex;
      }
      if (this.currentUserRoomIndex < this.userRooms.length - 1) {
        return this.currentUserRoomIndex + 1;
      }
      return -1;
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {
      this.fetch();
    },
    onHide: function () {},
    async fetch() {
      this.reload = false;
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const ship = this.run("get", "ship");
      const roomIndex = this.run("get", "currentUserRoomIndex");
      const room = rooms[roomIndex];
      if (!room.categoryType || !room.roomNumber) {
        return;
      }
      this.loading++;
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getPreferences",
        {
          rooms,
          numberOfRoom,
          roomIndex,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      if (!res.success) {
        this.run(
          "showMessage",
          res.message ?? "error",
          res.messageType,
          res.exitBooking,
          res.buttonLabel
        );
        this.loading--;
        return;
      }
      this.items = res.data.items;
      this.promotionCode =  res.data.promotion?.code ?? null;
      this.run("set", "promotionCode", this.promotionCode);
      this.run("set", "promotionData", res.data.promotion ?? null);

      for (const index in this.userRooms) {
        for (const k in this.items) {
          const item = this.items[k];
          let value = this.run(
            "get",
            "rooms." + index + ".preference." + item.name,
            false
          );
          if (value !== false) {
            for (const option of item.options) {
              if (option.value == value) {
                if (!option.status) {
                  value = false;
                  break;
                }
                this.run(
                  "set",
                  "rooms." + index + ".preference." + item.name,
                  option.value
                );
                this.run(
                  "set",
                  "rooms." + index + ".preference." + item.name + "_data",
                  option
                );
              }
            }
          }
          if (
            value === false &&
            typeof item.default != "undefined" &&
            item.default != ""
          ) {
            for (const option of item.options) {
              if (option.value == item.default) {
                this.run(
                  "set",
                  "rooms." + index + ".preference." + item.name,
                  option.value
                );
                this.run(
                  "set",
                  "rooms." + index + ".preference." + item.name + "_data",
                  option
                );
              }
            }
          }
        }
      }
      if (this.nextRoomIndex != -1 && this.items.length == 0) {
        this.reload = true;
        this.run("next");
      }

      this.loading--;
    },
    selectMaybe(e, item) {
      if (e.target.checked) {
        this.run(
          "set",
          "rooms." + this.currentUserRoomIndex + ".preference." + item.name,
          "maybe"
        );
      } else if (
        this.run(
          "get",
          "rooms." + this.currentUserRoomIndex + ".preference." + item.name
        ) == "maybe"
      ) {
        this.run(
          "set",
          "rooms." + this.currentUserRoomIndex + ".preference." + item.name,
          ""
        );
      }
    },
    select(item, option) {
      const value =
        this.run(
          "get",
          "rooms." + this.currentUserRoomIndex + ".preference." + item.name
        ) == option.value
          ? ""
          : option.value;
      this.run(
        "set",
        "rooms." + this.currentUserRoomIndex + ".preference." + item.name,
        value
      );
      this.run(
        "set",
        "rooms." +
          this.currentUserRoomIndex +
          ".preference." +
          item.name +
          "_data",
        value == "" ? null : option
      );
    },
    next() {
      for (const k in this.items) {
        const item = this.items[k];
        if (
          (item.required == 1 || item.required == true) &&
          this.run(
            "get",
            "rooms." + this.currentUserRoomIndex + ".preference." + item.name,
            false
          ) == false
        ) {
          this.errors[k] = item.message ?? this.tran("PLEASE_SELECT");
          this.run("scrollToError");
          return false;
        }
        delete this.errors[k];
      }
      this.reload = true;
      if (this.nextRoomIndex != -1) {
        this.run("set", "currentUserRoomIndex", this.nextRoomIndex);
        this.run("goStep", this.run("stepIndex", "CustomizeOffer"), "next");
        this.run("scrollToView");
        return false;
      }
      if (this.enableShowPromotionPopup) {
        if (!this.showPromotionPopup()) {
          return false;
        }
      } else {
        this.enableShowPromotionPopup = true;
      }

      return true;
    },
    showPromotionPopup() {
      const promotionData = this.run("get", "promotionData", '');
      if (!promotionData || !promotionData.popup_message) {
        return true;
      }

      this.run("popupAlert", promotionData.popup_message, [
        {
          label: promotionData.popup_button_yes
            ? promotionData.popup_button_yes
            : this.tran("YES"),
          class: "btn-success mb-2",
          action: () => {
            this.enableShowPromotionPopup = false;
            this.run("next");
          },
        },
        {
          label: promotionData.popup_button_no
            ? promotionData.popup_button_no
            : this.tran("NO"),
          class: "btn-danger mb-2",
          action: () => {
            if (promotionData.popup_button_no_remove) {
              this.run("set", "promotionCode", "");
              this.run("set", "promotionData", null);
              this.promotionCode = "";
            }
          },
        },
      ]);
      return false;
    },
    showDetail(item) {
      this.run("setRoot", "modalData", item.detail);
      this.run("setRoot", "modalDataClass", "v-modal-large");
    },
    async updatePromotion() {
      this.loading++;
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".promotion",
        { promotionCode: this.promotionCode }
      );
      if (res && res.success && res.data) {
        this.run("set", "promotionCode", this.promotionCode);
        this.run("set", "promotionData", res.data);
        this.showPromotionPopup();
      }
      if (res && res.message) {
        this.run(
          "showMessage",
          res.message,
          res.messageType,
          res.exitBooking,
          res.buttonLabel
        );
      }

      this.loading--;
    },
    removePromotion() {
      this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".removePromotion",
        { promotionCode: this.promotionCode }
      );
      this.run("set", "promotionCode", "");
      this.run("set", "promotionData", null);
      this.promotionCode = "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
